// extracted by mini-css-extract-plugin
export var card = "ContentfulComponentImageTextCard-module--card--5bb5b";
export var icon = "ContentfulComponentImageTextCard-module--icon--424d7";
export var image = "ContentfulComponentImageTextCard-module--image--bda0e";
export var imageContainer = "ContentfulComponentImageTextCard-module--imageContainer--67d3f";
export var paragraph = "ContentfulComponentImageTextCard-module--paragraph--61706";
export var text = "ContentfulComponentImageTextCard-module--text--818be";
export var withFloatingImage = "ContentfulComponentImageTextCard-module--withFloatingImage--3f14c";
export var withIcon = "ContentfulComponentImageTextCard-module--withIcon--f1731";
export var withImage = "ContentfulComponentImageTextCard-module--withImage--c6b52";